import { playTone } from "../../lib/dtmf";

const KEYS: [string, string][] = [
  ["1", ""], ["2", "ABC"], ["3", "DEF"], ["4", "GHI"], ["5", "JKL"], ["6", "MNO"],
  ["7", "PQRS"], ["8", "TUV"], ["9", "WXYZ"], ["*", ""], ["0", "+"], ["#", ""],
];

/** `tones`: play keypad sounds locally. Off during calls, where the Twilio SDK plays them as digits are sent. */
export function Keypad({ onPress, label = "Dial pad", disabled, tones = true }: { onPress: (digit: string) => void; label?: string; disabled?: boolean; tones?: boolean }) {
  return (
    <div role="group" aria-label={label} className="grid grid-cols-3 gap-2.5">
      {KEYS.map(([digit, letters]) => (
        <button
          key={digit}
          type="button"
          disabled={disabled}
          onClick={() => { if (tones) playTone(digit); onPress(digit); }}
          aria-label={digit === "*" ? "Star" : digit === "#" ? "Pound" : digit}
          className="focus-ring flex h-14 flex-col items-center justify-center rounded-2xl bg-white/55 text-default shadow-[0_1px_0_rgb(255_255_255/0.9)_inset,0_6px_16px_-10px_rgb(30_41_82/0.35)] ring-1 ring-inset ring-white/70 transition-all hover:-translate-y-px hover:bg-white/85 active:translate-y-0 active:bg-accent-50 disabled:opacity-50"
        >
          <span className="text-xl font-light leading-none">{digit}</span>
          <span className="mt-0.5 h-3 text-[10px] tracking-widest text-subtle">{letters}</span>
        </button>
      ))}
    </div>
  );
}
